export default __webpack_public_path__ + "static/media/CryptoStat_logos_transparent.16211fb5.png";